import ModernBreakdown from './ModernBreakdown';

export default ModernBreakdown;
